import React, { PureComponent } from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import withAuth from "../auth/withAuth";

class Content extends PureComponent {
  render = () => {
    const { routes, Login, userInfo, refreshAuth } = this.props;
    let j = 0;
    return (
      <Switch>
        {routes.map(route =>
          route.authorize ? (
            <Route
              exact={route.exact}
              key={`route-${j++}`}
              path={route.path}
              render={() =>
                userInfo ? (
                  <Route {...route} />
                ) : (
                  <Login onSubmit={refreshAuth} />
                )
              }
            />
          ) : (
            <Route key={`route-${j++}`} {...route} />
          )
        )}
      </Switch>
    );
  };
}

export default withAuth(withRouter(Content));
